import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';

export const useGA4OAuthCallback = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ga4Success = params.get('ga4_success');
    const ga4Error = params.get('ga4_error');

    if (ga4Success === 'true') {
      toast.success('Google Analytics 4 connected successfully!', {
        duration: 4000,
        position: 'top-right',
        style: {
          background: '#10B981',
          color: 'white',
        },
        iconTheme: {
          primary: 'white',
          secondary: '#10B981',
        },
      });
      
      // Clean up URL parameters
      const newParams = new URLSearchParams(location.search);
      newParams.delete('ga4_success');
      const newSearch = newParams.toString();
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
      history.replace(newUrl);
    }

    if (ga4Error) {
      let errorMessage = 'Failed to connect Google Analytics 4';
      
      // Map specific error codes to user-friendly messages
      switch (ga4Error) {
        case 'access_denied':
          errorMessage = 'Authorization was denied. Please try again and grant necessary permissions.';
          break;
        case 'missing_parameters':
          errorMessage = 'Authentication failed due to missing parameters. Please try again.';
          break;
        case 'invalid_state':
          errorMessage = 'Authentication failed due to invalid session. Please try again.';
          break;
        case 'state_expired':
          errorMessage = 'Authentication session expired. Please try again.';
          break;
        case 'organization_not_found':
          errorMessage = 'Organization not found. Please contact support.';
          break;
        case 'oauth_not_configured':
          errorMessage = 'OAuth is not properly configured. Please contact support.';
          break;
        case 'callback_failed':
          errorMessage = 'Authentication process failed. Please try again.';
          break;
        default:
          errorMessage = `Authentication failed: ${ga4Error}`;
      }

      toast.error(errorMessage, {
        duration: 6000,
        position: 'top-right',
        style: {
          background: '#EF4444',
          color: 'white',
        },
        iconTheme: {
          primary: 'white',
          secondary: '#EF4444',
        },
      });
      
      // Clean up URL parameters
      const newParams = new URLSearchParams(location.search);
      newParams.delete('ga4_error');
      const newSearch = newParams.toString();
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
      history.replace(newUrl);
    }
  }, [location.search, history]);
};

export default useGA4OAuthCallback;
